export default {
  common: {
    confirm: 'OK',
    cancel: 'Cancel',
    close: 'Close',
    gender: {
      male: 'Male/M',
      female: 'Female/F'
    },
    money: '<currency>JPY</currency> <amount>{{amount}}</amount>',
    moneyText: 'JPY {{amount}}',
    refundMethod: {
      credit: 'Credit card',
      union: 'UnionPay',
      alipay: 'Alipay',
      wechatpay: 'WeChat Pay',
      cash: 'Cash'
    }
  },
  components: {
    passportCamera: {
      hint: 'Align the passport photo page with the frame',
      unavailable:
        'Camera unavailable. Please use the system camera or choose a photo.',
      systemCamera: 'Use system camera',
      album: 'Album',
      shoot: 'Take photo'
    }
  },
  views: {
    home: {
      title: 'Home',
      notice: 'You have consumption tax pending refund',
      apply: 'Apply for refund',
      historyTitle: 'Application history',
      total: 'Total',
      refundAmount: 'Estimated refund',
      empty: 'No refund records yet',
      loadError: 'Failed to load. Please try again later.',
      applyError: 'Failed to submit the request. Please try again later.',
      status: {
        awaitingCustoms: 'Awaiting customs confirmation',
        notEligible: 'Not eligible for refund',
        refunding: 'Refund in progress',
        refunded: 'Refunded',
        refundFailed: 'Refund failed'
      }
    },
    landing: {
      title: 'Japan Tax-Free Refund Service',
      description:
        'You accessed this service via the URL\nafter your departure confirmation',
      next: 'Continue'
    },
    login: {
      title: 'Japan Tax-Free Refund Service',
      google: 'Sign in with Google',
      email: 'Sign in with email',
      emailLabel: 'Email address',
      sendLink: 'Send sign-in link',
      resendLink: 'Resend sign-in link',
      linkSent:
        'A sign-in link has been sent to {{email}}.\nPlease check your inbox.',
      confirmEmail: 'Please re-enter your email address to complete sign-in.',
      submit: 'Sign in',
      loginError: 'Sign-in failed. Please try again later.',
      sendError: 'Failed to send. Please try again later.'
    },
    passportInfo: {
      title: 'Passport Information',
      nationality: 'Nationality',
      passportNumber: 'Passport number',
      lastName: 'Surname',
      firstName: 'Given names',
      gender: 'Sex',
      dateOfBirth: 'Date of birth',
      dateOfExpiry: 'Date of expiry',
      confirm: 'Confirm',
      rescan: 'Incorrect? Retake photo',
      scanError: 'Could not read the passport. Please take the photo again.',
      bindError: 'Failed to register. Please try again later.'
    },
    passports: {
      title: 'Passports',
      add: 'Add new passport',
      delete: 'Delete',
      deleteConfirm: 'Delete passport {{number}}?',
      loadError: 'Failed to load. Please try again later.',
      deleteError: 'Failed to delete. Please try again later.',
      selectError: 'Failed to switch passport. Please try again later.',
      logout: 'Log out'
    },
    taxInfo: {
      title: 'Enter Tax Refund Document Info',
      passportLabel: 'Passport Number',
      passportPlaceholder: 'Please enter',
      lastNameLabel: 'Last Name',
      lastNamePlaceholder: 'Please enter',
      firstNameLabel: 'First Name',
      firstNamePlaceholder: 'Middle and first name',
      expiryLabel: 'Passport Expiry Date',
      verifyError:
        'Passport verification failed. Please check the information you entered.',
      submit: 'Verify and continue'
    },
    residenceCert: {
      title: 'Residence Status Certificate',
      notice:
        'To verify that you have lived overseas for at least 2 years, please submit one of the certificates below.',
      documentLabel: 'Overseas Residence Proof (any one)',
      types: {
        permitDocumentTypeKosekiFukuhyo: 'Family register supplement',
        permitDocumentTypeResidenceCertificate:
          'Overseas residence certificate',
        permitDocumentTypeMynumberCard: 'My Number card'
      },
      residenceStatusLabel: 'Residence status',
      residenceStatusPlaceholder: 'Please select',
      permitTypes: {
        shipTourism: 'Ship tourism landing',
        crew: 'Crew landing',
        emergency: 'Emergency landing',
        distress: 'Distress landing',
        sofa: 'US military member',
        portCall: 'Port-of-call landing',
        transit: 'Transit landing'
      },
      entryDateLabel: 'Date of entry',
      settledDateLabel: 'Date settled overseas',
      datePlaceholder: 'yyyy-mm-dd',
      addressLabel: 'Overseas residence address',
      countryPlaceholder: 'Please select',
      uploadLabel: 'Upload image',
      capture: 'Photo',
      removeImage: 'Remove image',
      submit: 'Upload',
      verifyError:
        'This link is invalid or has expired. Please scan the QR code again.'
    },
    uploadResult: {
      title: 'Upload Result',
      done: 'Upload complete',
      desc: 'Return to the Kiosk to continue',
      failed: 'Upload failed',
      failedDesc: 'Please try again'
    },
    statusDetail: {
      title: 'Application Status',
      orderNo: 'Order No. {{id}}',
      appliedAt: 'Applied on {{date}}',
      appliedAt_method: 'Applied on {{date}} | {{method}}',
      total: 'Total',
      taxAmount: 'Tax',
      refundFee: 'Fee',
      refundAmount: 'Estimated refund',
      customsNotice:
        'Please have your purchased items checked at customs when you leave Japan. The refund starts once the check is completed.',
      steps: {
        received: 'Application received',
        customsPending: 'Customs departure check in progress',
        customs: 'Customs departure confirmed',
        customsFailed: 'Customs check not passed',
        refunding: 'Refund in progress',
        refunded: 'Refunded',
        refundFailed: 'Refund failed'
      },
      remitNote: 'Usually 3–5 business days',
      retry: 'Apply again',
      retryError: 'Failed to apply again. Please try again later.',
      loading: 'Loading...',
      loadError: 'Failed to load. Please try again later.'
    },
    notFound: {
      title: 'Page not found',
      description:
        'The page you are looking for does not exist or has been moved.',
      backHome: 'Back to home'
    }
  }
};
